import { ElementType } from '@/App/remotion/MainPlayer/types/Element/Type';

export const MINIMUM_TRACK_TIME_DIFFERENCE = 1;

export const TypeIconMap = {
  [ElementType.IMAGE]: 'IconPhoto',
  [ElementType.LOTTIE]: 'IconBoom',
  [ElementType.VIDEO]: 'IconVideo',
  [ElementType.AUDIO]: 'IconMusic',
  [ElementType.TEXT]: 'IconFileText'
};

export const ElementResizeSideEnum = {
  START: 'start',
  END: 'end',
  CENTER: 'center'
} as const;
